/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CourseBulkRegisterEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('COURSE_BULK_REGISTER_ENABLED')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class CourseBulkRegisterEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CourseBulkRegisterEnabledSettingParser.decode(input).map(res => new CourseBulkRegisterEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return CourseBulkRegisterEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CourseBulkRegisterEnabledSettingParser.encode(data);
    }
    static schema() {
        return CourseBulkRegisterEnabledSettingParser.schema();
    }
}
